<template>
    <div class="content content-1">

        <SplitText :is-type="'h1'" class="t-h1 title anim-line-3">
            <span>
                Web and contact mining
            </span>
        </SplitText>

        <div class="block t-text block u-relative">

            <p class="text anim-2">
                <span>
                    We scrape the information you need and find the people who matter to you most.
                </span>
            </p>

            <ul class="list anim-1">
                <li class="item">
                    Lead generation
                </li>
                <li class="item">
                    Database enrichment
                </li>
                <li class="item">
                    Web scraping
                </li>
                <li class="item">
                    Product scraping
                </li>
                <li class="item">
                    Competitor scraping
                </li>
            </ul>

        </div>

    </div>
</template>
<script>
import SplitText from '@/components/SplitText'

export default
{
    name: 'Mining',

    components:
    {
        SplitText
    }
}
</script>
